import { type IWidgetDirectiveType } from '@framework/engine/schema/directives/IWidgetDirectiveType.ts';
import { isInputWidget } from '@framework/engine/schema/widgets/repository/inputs/isInputWidget.ts';
import { WidgetType } from '@framework/engine/schema/widgets/Widget.ts';
import { FormBuilderMetaFlags } from '@framework/engine/validator/form-builder/flags/FormBuilderMetaFlags.ts';
import {
  type ITableSaveDirective,
  TableSaveDirectiveSchema,
} from './ITableSaveDirective.ts';
import { TableSaveDirectiveConfigComponent } from './TableSaveDirectiveConfigComponent.tsx';

export const TableSaveDirectiveType: IWidgetDirectiveType<ITableSaveDirective> =
  {
    name: 'tableSave',
    key: 'tableSave',
    allowsWidget: (widget, widgetType) =>
      isInputWidget(widget) && widget.type !== WidgetType.Repeatable,
    configComponent: TableSaveDirectiveConfigComponent,
    configSchema: TableSaveDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema, flags }) => {
      if (!directiveConfig.name) {
        console.warn(`[TableSaveDirectiveType] Missing name in config`);
        return schema;
      }

      if (flags[FormBuilderMetaFlags.SkipValidationRules]) {
        // Se le regole di validazione non sono attive, vuol dire che
        // non è il campo "principale" del Widget, quindi non dobbiamo
        // esportarlo.
        return schema;
      }

      // Salviamo il valore del campo da esportare nei meta, così da accedervi
      // in fase di estrazione
      return schema.meta?.({
        directiveTableSave: directiveConfig.name,
      });
    },
    supportedSectionTypes: ['BACKOFFICE', 'FRONTOFFICE'],
  };
